// extracted by mini-css-extract-plugin
export default {"container":"ObsBox_container__ZItM5","select":"ObsBox_select__shqKq","SelectOptions":"ObsBox_SelectOptions__ggHTq","plot":"ObsBox_plot__uIi-L"};